import { OdbsComponent } from 'src/app/odbs/odbs.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { EinzelabfrageComponent } from './einzelabfrage/einzelabfrage.component';
import { VeraenderungsmitteilungComponent } from './veraenderungsmitteilung/veraenderungsmitteilung.component';
import { ContentComponent } from './content/content.component';
import { BezuegestelleFehlerComponent } from '../shared/components/bezuegestelle-fehler/bezuegestelle-fehler.component';

const routes: Routes = [
    {
        path: '',
        component: OdbsComponent,
        children: [
            {
                path: '',
                component: ContentComponent,
                children: [
                    { path: '', redirectTo: 'einzelabfrage', pathMatch: 'full' },
                    {
                        path: 'einzelabfrage',
                        component: EinzelabfrageComponent,
                        pathMatch: 'full',
                    },
                    {
                        path: 'veraenderungsmitteilung',
                        component: VeraenderungsmitteilungComponent,
                        pathMatch: 'full',
                    },
                ],
            },
            { path: 'bezuegestelle-fehler', component: BezuegestelleFehlerComponent }
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: [],
})
export class OdbsRoutingModule {}
